import { useDropzone } from 'react-dropzone';
import { Trans } from 'react-i18next';

import { Column, Row } from 'components/Blocks';
import { FolderSearchIcon } from 'components/Icons';

import { cn } from 'styles';
import { useLang } from 'hooks/lang';

interface FileDropzoneProps {
  className?: string;
  multiple?: boolean;
  disabled?: boolean;
  acceptedFormats?: string[];

  onFiles: (files: File[]) => void;
}

export function FileDropzone({
  acceptedFormats,
  multiple = true,
  className,
  onFiles,
  disabled,
}: FileDropzoneProps) {
  const { t } = useLang();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onFiles,
    multiple,
    accept: acceptedFormats,
    disabled,
  });

  return (
    <div className={cn('flex justify-center rounded-md border p-3', className)} {...getRootProps()}>
      <input {...getInputProps()} />

      {isDragActive ? (
        <span className="text-sm font-medium">{t('drop-file-here')}</span>
      ) : (
        <Column alignItems="center" gap="1">
          <span className="text-center text-sm font-medium">
            <Trans>drag-and-drop-files-or</Trans>
          </span>

          <Row
            gap="2"
            justifyContent="center"
            className="h-6 w-[150px] rounded-lg bg-primary text-sm font-semibold text-primary-foreground"
          >
            <FolderSearchIcon size={16} />
            {t('browse')}
          </Row>
        </Column>
      )}
    </div>
  );
}
